
import { COLUMNS_REPORTE_EMBARQUE_SECTOR_3_LINEA_6_TO_PRINT, COLUMNS_REPORTE_EMBARQUE_SECTOR_3_LINEA_6 } from './constantesreporteEmbarqueSector3Linea6'
import { ReporteEmbarqueSector3Linea6Service } from '../../../../../../models/movimiento/ReporteEmbarquePorSector/tabla_reporte_embarque_sector_3_linea_6'
import { pdfCustomToolbarGenerator } from '../../../../../../models/tools/generarPdf'
import { TABLA_REPORTE_EMBARQUE_SECTOR_3_LINEA_6 } from '../../../../../../config/tables'

export function actualizarDatosParaMuiTable (cereal, cerealVariedad, etiqueta) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_REPORTE_EMBARQUE_SECTOR_3_LINEA_6
    })
    const promiseReporteEmbarqueSector3Linea6 = ReporteEmbarqueSector3Linea6Service.getDataReporteEmbarqueSector3Linea6(cereal, cerealVariedad, etiqueta)
    const promiseReporteEmbarqueSector3Linea6Total = ReporteEmbarqueSector3Linea6Service.getDataReporteEmbarqueSector3Linea6Total(cereal, cerealVariedad, etiqueta)
    Promise.all([promiseReporteEmbarqueSector3Linea6, promiseReporteEmbarqueSector3Linea6Total]).then(callback)
    function callback (dataArray) {
      const dataCombinada = dataArray[0].filas || []
      const filaTotalArreglada = (dataArray[1] || [])[0] || {}
      filaTotalArreglada['cereal'] = 'Total'
      dataCombinada.push(filaTotalArreglada)
      const customToolbar = pdfCustomToolbarGenerator(
        'Reporte Embarque Sector 3 Linea 6',
        dataCombinada,
        COLUMNS_REPORTE_EMBARQUE_SECTOR_3_LINEA_6_TO_PRINT,
        'portrait')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_REPORTE_EMBARQUE_SECTOR_3_LINEA_6,
          data: dataCombinada,
          title: `Reporte Embarque Sector 3 Linea 6`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { customToolbar, print: false }
        },
        id: TABLA_REPORTE_EMBARQUE_SECTOR_3_LINEA_6
      })
    }
  }
}
